module.exports = __webpack_public_path__ + "static/img/second.20d59519.png";